import clsx from "clsx";

import FieldLabel from "../Field-Label";

export interface Props<T extends number | string | boolean> {
  /** Field Name */
  name?: string;
  /** Label. Will be above the radio buttons */
  label?: React.ReactNode;
  labelTags?: React.ReactNode[] | React.ReactNode;
  /** Radio Options */
  options: {
    key: T;
    label: React.ReactNode;
  }[];
  /** Current Selection */
  selected: T;
  /** OnClick call back */
  onChange: (key: T) => any;
  /** What color should the checked button be? */
  checkedColor?: "primary" | "secondary" | "danger";
  /** Error. Will be below radio buttons, and Help */
  error?: React.ReactNode;
  /** Help. Will be below radio buttons. If error is True, this will also be Red. */
  help?: React.ReactNode;
  /** Is the field required? This is PURELY A VISUAL representation. */
  required?: boolean;
  /** Should the buttons be in a column or row? */
  orientation?: "horizontal" | "vertical";
  optionClasses?: string;
  className?: string;
}

/**
 * Standard Radio Button
 *
 */
function RadioButton<T extends number | string>({
  label,
  labelTags,
  name,
  options,
  selected,
  onChange,
  checkedColor = "secondary",
  help,
  error,
  required,
  orientation = "horizontal",
  optionClasses,
  className,
}: Props<T>) {
  return (
    <>
      {label && (
        <FieldLabel
          name={name}
          label={label}
          error={!!error}
          required={required}
          tags={labelTags}
        />
      )}
      <div
        className={clsx([
          !className?.includes("m-") &&
            !className?.includes("mt-") &&
            "mt-2 ml-2",
          orientation === "vertical" && "flex flex-col",
          className,
        ])}
      >
        {options.map((opt, i) => (
          <label
            key={i}
            className={clsx([
              "inline-flex",
              "items-center",
              orientation === "horizontal" && "ml-6 first:ml-0",
              optionClasses,
            ])}
          >
            <input
              type="radio"
              className={`form-radio ${
                checkedColor === "primary" ? "text-primary-main" : ""
              } ${checkedColor === "danger" ? "text-error-main" : ""}`}
              name={name}
              value={opt.key}
              onChange={() => opt.key !== selected && onChange(opt.key)}
              checked={selected === opt.key}
            />
            <span className="ml-2 text-gray-900 cursor-pointer">
              {opt.label}
            </span>
          </label>
        ))}
      </div>
      {help && (
        <div
          className={clsx(
            "text-xs",
            !!error ? "text-error-main" : "text-gray-500"
          )}
        >
          {help}
        </div>
      )}
      {error && <div className="text-error-main text-xs">{error}</div>}
    </>
  );
}

export default RadioButton;
